"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var client_password_1 = require("./client-password");
Object.defineProperty(exports, "AccountsClientPassword", { enumerable: true, get: function () { return client_password_1.AccountsClientPassword; } });
//# sourceMappingURL=index.js.map